<template>
  <div>
    <va-modal
      class="modal"
      v-model="showEdition"
      :okText="saveMessage"
      cancelText="Annuler"
      max-width="100%"
      v-on:ok="modifyDevis"
      v-on:cancel="closeModal"
      noEscDismiss
      noOutsideDismiss
      :hideDefaultActions="true"
      disabled
      title="Edition du devis"
    >
      <div class="forcewidth">
        <div class="row row-inside">
          <div class="flex md5">
            <div class="row row-inside">
              <div class="flex md12">
                <va-select
                  :options="partenairesListe"
                  v-model="devis.partenaire"
                  textBy="nom"
                  keyBy="idpartenaire"
                  searchable
                  label="Annonceur"
                  @input="newPartenaire"
                />
              </div>
            </div>
            <div class="row row-inside">
              <div class="flex md6 pr-2">
                <va-select
                  :options="mainContactList"
                  v-model="devis.mainContactDevis"
                  textBy="display"
                  keyBy="idcontacts_partenaire"
                  label="Adresse principale du devis"
                  clearable="false"
                />
              </div>
              <div class="flex md6 pl-2">
                <va-select
                  :options="mainContactList"
                  v-model="devis.mainContactBilling"
                  textBy="display"
                  keyBy="idcontacts_partenaire"
                  label="Adresse de facturation"
                />
              </div>
            </div>
            <div class="row row-inside">
              <div class="flex md6">
                <div class="row row-inside">
                  <div class="flex md12">
                    Attribution:
                    {{
                      devis.user_attribution
                        ? devis.user_attribution
                        : "Non attribué"
                    }}
                  </div>
                  <div class="flex md6">Changer l'attribution?</div>
                  <div class="flex md1">
                    <va-checkbox v-model="attribution" />
                  </div>
                </div>
              </div>

              <div class="flex md3">TVA non applicable:</div>
              <div class="flex md1">
                <va-checkbox v-model="devis.tva_na" />
              </div>
            </div>
            <div class="row row-inside">
              <div class="flex md6 mt-3">
                <va-button
                  @click="showCommentsClient = true"
                  class="fullwidth"
                  :color="devis.comment_client ? 'success' : 'info'"
                  >Commentaires client</va-button
                >
              </div>
              <div class="flex md6 mt-3">
                <va-toggle
                  v-model="devis.isprospection"
                  label="Devis de prospection"
                />
              </div>
            </div>
          </div>
          <div class="flex md5">
            <div class="row row-inside">
              <div class="flex md12 offset--md1">
                <div class="row row-inside">
                  <div class="flex md4">
                    Engagement sur {{ decomptesNumeros }} numéros
                  </div>
                  <div class="flex md6">{{ decomptePages.text }}</div>
                  <div class="flex md2">{{ decomptePages.total }}</div>
                  <div class="flex md4">Total: {{ montants.total }} €</div>
                  <div class="flex md4">Remise: {{ montants.remise }} €</div>
                  <div class="flex md4">
                    Total remisé: {{ montants.total - montants.remise }} €
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex md2">
            <div class="row row-inside">
              <div class="flex md12">
                <va-button @click="closeModal" class="fullwidth" color="info"
                  >Annuler</va-button
                >
              </div>
              <div class="flex md12">
                <va-button
                  @click="modifyDevis"
                  class="fullwidth"
                  :color="isvalid"
                  :disabled="isvalid === 'info' || !isChanged"
                  >Modifier le devis</va-button
                >
              </div>
              <div class="flex md12">
                <va-button
                  @click="cancelDevis"
                  class="fullwidth"
                  color="danger"
                  v-if="!isBilled"
                  >Annuler le devis</va-button
                >
              </div>
            </div>
          </div>
        </div>
        <div class="row row-inside mt-4">
          <div class="flex md12">
            <h4>Engagements sur les numéros</h4>
          </div>
          <div class="flex md12">
            <div
              class="pub"
              v-for="publication in publicationsListeFiltered"
              :style="{ backgroundColor: backgroundColor(publication) }"
              @click="addAnnonce(publication)"
            >
              <div class="number">
                {{ publication.numero ? publication.numero : "Hors-Série" }}
              </div>
              <div class="date">
                {{ publication.date_previsionnelle }}
              </div>
            </div>
          </div>
        </div>
        <div class="row row-inside mt-4">
          <div class="flex md12">
            <h4>Annonces</h4>
          </div>
          <div class="flex md11">
            <div class="row row-inside">
              <div class="flex md1">Numéro</div>
              <div class="flex md1">Date prévisionnelle</div>
              <div class="flex md2">Nom</div>
              <div class="flex md1">Type</div>
              <div class="flex md1">Taille</div>
              <div class="flex md1">Montant</div>
              <div class="flex md1">Remises</div>
              <div class="flex md1">Total HT</div>
              <div class="flex md1">Facturation</div>
            </div>
          </div>
          <div
            class="flex md12 separated annonces"
            v-for="(annonce, index) in listeAnnonces"
            @click="selectAnnonce(index)"
          >
            <div class="row row-inside">
              <div class="flex md11">
                <div class="row row-inside">
                  <div class="flex md1">
                    {{ annonce.numero ? annonce.numero : "Hors-Série" }}
                  </div>
                  <div class="flex md1">
                    {{ annonce.date_previsionnelle }}
                  </div>
                  <div class="flex md2">
                    {{ annonce.nom }}
                  </div>
                  <div class="flex md1">
                    {{ annonce.type }}
                  </div>
                  <div class="flex md1">{{ annonce.size }} Pages</div>
                  <div class="flex md1">{{ annonce.montant }} €</div>
                  <div class="flex md1">
                    <p>{{ annonce.remise }} %</p>
                    <p>
                      {{ annonce.remise_fixe ? annonce.remise_fixe + "€" : "" }}
                    </p>
                  </div>
                  <div class="flex md1">
                    {{ montantTotal(annonce) }}
                    €
                  </div>
                  <div class="flex md1">
                    {{
                      annonce.idpartenaire_facturation ? "Autre" : "Standard"
                    }}
                  </div>
                  <div class="flex md2">
                    <va-select
                      :options="listTemplate"
                      v-model="templateSelect"
                      textBy="nom"
                      keyBy="idannonces_modele"
                      searchable
                      label="Recherche d'un template"
                    />
                  </div>
                </div>
              </div>
              <div class="flex md1">
                <div class="row row-inside" v-if="!annonce.idfacturation">
                  <div class="flex md3 offset--md2">
                    <va-button
                      flat
                      icon="fa fa-edit"
                      color="info"
                      @click="editAnnonce(index)"
                    />
                  </div>
                  <div class="flex md5">
                    <va-button
                      flat
                      icon="fa fa-remove"
                      color="info"
                      @click="deleteAnnonce(index)"
                    />
                  </div>
                </div>
                <div class="row row-inside" v-else>
                  <div class="flex md3 offset--md2">Facturé</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </va-modal>
    <va-modal
      class="modal modalcomments"
      v-model="showCommentsClient"
      :okText="saveMessage"
      cancelText="Annuler"
      title="Commentaires client"
      :hideDefaultActions="true"
      size="large"
      maxWidth="100%"
    >
      <div class="force-width-comments">
        <va-input
          v-model="comment_client"
          label="Commentaire:"
          type="textarea"
          autosize
          :minRows="5"
          :maxRows="15"
        ></va-input>
      </div>
    </va-modal>

    <va-modal
      class="modal"
      v-model="showModal"
      :okText="saveMessage"
      cancelText="Annuler"
      v-on:cancel="closeModifAnnonce"
      title="Editer Annonce"
      :hideDefaultActions="true"
    >
      <div class="force-width-medium" v-if="idAnnonce !== null">
        <div class="flex md12">
          <div class="row row-inside">
            <div class="flex md4">
              <va-input
                disabled
                v-model="listeAnnonces[idAnnonce].numero"
                placeholder="Numéro, Hors-série"
                label="Numéro"
              />
            </div>
            <div class="flex md7 offset--md1">
              <va-date-picker
                disabled
                :config="{ dateFormat: 'd-m-Y' }"
                v-model="
                  moment(
                    listeAnnonces[idAnnonce].date_previsionnelle,
                    'YYYY-MM-DD'
                  ).format('DD-MM-YYYY')
                "
                label="Date Prévisionnelle"
              />
            </div>
          </div>
        </div>
        <div class="flex md12">
          <va-input
            v-model="listeAnnonces[idAnnonce].nom"
            placeholder="Nom"
            label="Nom"
          />
        </div>
        <div class="flex md12">
          <va-input
            v-model="listeAnnonces[idAnnonce].commentaire"
            placeholder="Commentaire"
            label="Commentaire"
            type="textarea"
            :minRows="3"
            :maxRows="8"
          />
        </div>
        <div class="flex md12">
          <va-select
            :options="listType"
            v-model="listeAnnonces[idAnnonce].type"
            label="Type d'annonce"
          />
        </div>
        <div class="flex md12">
          <va-select
            :options="listSize"
            v-model="listeAnnonces[idAnnonce].size"
            label="Taille de l'annonce"
          />
        </div>
        <div class="flex md12 my-1">
          <va-checkbox v-model="specialBilling" label="Facturation spéciale" />
        </div>
        <div class="flex md12" v-show="specialBilling">
          <va-select
            :options="partenairesListe"
            v-model="partenaireSpecialBilling"
            textBy="nom"
            keyBy="idpartenaire"
            searchable
            label="Recherche d'un annonceur"
          />
        </div>
        <div class="flex md12" v-show="specialBilling">
          <va-select
            :options="listContactSpecialBilling"
            v-model="contactSpecialBilling"
            textBy="display"
            keyBy="idcontacts_partenaire"
            label="Adresse principale du devis"
          />
        </div>

        <div class="flex md12">
          <va-input
            v-model="listeAnnonces[idAnnonce].montant"
            placeholder="Montant"
            label="Montant"
            type="number"
            @input="updateMontant"
          />
        </div>
        <div class="flex md12">
          <div class="flex row row-inside">
            <div class="flex md6 pr-1">
              <va-input
                v-model="listeAnnonces[idAnnonce].remise"
                placeholder="Remise"
                label="Remise (%)"
                type="number"
                min="0"
                max="100"
                @input="updateRemiseFromPe"
              />
            </div>
            <div class="flex md6 pl-1">
              <va-input
                v-model="remiseChiffre"
                placeholder="Remise - Montant"
                label="Remise (€)"
                type="number"
                @input="updateRemiseFromNb"
              />
            </div>
          </div>
        </div>

        <div class="flex md12">
          <va-input
            v-model="listeAnnonces[idAnnonce].remise_fixe"
            placeholder="Remise"
            label="Remise additionnelle (€)"
            type="number"
          />
        </div>

        <div class="flex md12">
          <p>Montant total</p>
          <p>
            {{ montantTotal(listeAnnonces[idAnnonce]) }}
          </p>
        </div>
      </div>
    </va-modal>

    <va-modal
      class="modal"
      v-model="showDeleteConfirm"
      okText="Confirmer"
      cancelText="Annuler"
      v-on:cancel="showDeleteConfirm = false"
      v-on:ok="deleteDevis"
      title="Supprimer l'annonce"
    >
      Confirmer l'annulation du devis?
    </va-modal>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { cloneDeep, find, isEqual, sortedUniq, sortBy, debounce } from "lodash";

export default {
  name: "devis-modification",
  props: ["value", "iddevis"],
  data() {
    return {
      devis: {
        idattribution: null,
        tva_na: false,
        partenaire: { idpartenaire: null, nom: null },
        mainContactBilling: { idcontacts_partenaire: null, display: null },
        mainContactDevis: { idcontacts_partenaire: null, display: null },
        user_attribution: null,
        isprospection: false,
      },
      comment_client: null,
      showCommentsClient: false,
      devisBak: null,
      attribution: false,
      showModal: false,
      moment: moment,
      showEdition: false,
      mainContactList: [],
      partenairesListe: [],
      publicationsListe: [],
      listTemplate: [],
      listeAnnonces: [],
      listAnnoncesBak: [],
      isBilled: false,

      partenaireSpecialBilling: { idpartenaire: null, nom: null },
      contactSpecialBilling: { idcontacts_partenaire: null },
      listContactSpecialBilling: [],
      idAnnonce: null,
      templateSelect: this.initTemplate(),
      listSize: ["1/4", "1/2", "1"],
      listType: ["presse"],
      action: false,
      specialBilling: false,
      isChanged: false,
      showDeleteConfirm: false,
      remiseChiffre: null,
    };
  },
  mounted() {
    this.resetDevis();
    this.showEdition = this.value; // initialize internal variables
  },
  methods: {
    updateMontant: debounce(function (montant) {
      // calculate the € corresponding to the %

      this.listeAnnonces[this.idAnnonce].montant = parseFloat(montant);
    }, 400),
    updateRemiseFromPe: debounce(function (remiseP) {
      // calculate the € corresponding to the %

      if (this.listeAnnonces[this.idAnnonce].montant) {
        this.remiseChiffre = (
          (this.listeAnnonces[this.idAnnonce].montant * remiseP) /
          100
        ).toFixed(2);
      }
    }, 400),
    updateRemiseFromNb: debounce(function (remiseNb) {
      // calculate the % needed to reach this remise
      if (this.listeAnnonces[this.idAnnonce].montant) {
        this.listeAnnonces[this.idAnnonce].remise = parseFloat(
          (
            (100 * remiseNb) /
            this.listeAnnonces[this.idAnnonce].montant
          ).toFixed(5)
        );
      }
    }, 400),
    montantTotal(annonce) {
      let montant = annonce.montant;
      let remise = annonce.remise;
      let remise_fixe = annonce.remise_fixe
        ? parseFloat(annonce.remise_fixe)
        : 0;
      return (montant * (1 - remise / 100) - remise_fixe).toFixed(2);
    },
    cancelDevis() {
      this.showDeleteConfirm = true;
    },
    newPartenaire(partenaire) {
      this.changePartenaire(partenaire);
    },
    async getDevis() {
      try {
        let resTmp = await axios.get("/api/publications/devis", {
          params: { iddevis: this.iddevis },
        });
        let devisTmp = resTmp.data;

        this.devis.tva_na = devisTmp.tva_na ? true : false;

        this.devis.isprospection = devisTmp.isprospection ? true : false;

        this.devis.comment_client = devisTmp.comment_client;

        this.devis.partenaire = {
          idpartenaire: devisTmp.idpartenaire,
          nom: find(this.partenairesListe, {
            idpartenaire: devisTmp.idpartenaire,
          }).nom,
        };

        // contact for billing and devis
        let listContacts = await this.getContacts(devisTmp.idpartenaire);
        let emptyContact = {
          idcontacts_partenaire: null,
          display: "Entreprise - Adresse principale",
        };
        listContacts.unshift(emptyContact);
        this.mainContactList = listContacts;

        if (devisTmp.idcontacts_partenaire_billing) {
          this.devis.mainContactBilling = find(listContacts, {
            idcontacts_partenaire: devisTmp.idcontacts_partenaire_billing,
          });
        } else {
          this.devis.mainContactBilling = emptyContact;
        }

        if (devisTmp.idcontacts_partenaire_devis) {
          this.devis.mainContactDevis = find(listContacts, {
            idcontacts_partenaire: devisTmp.idcontacts_partenaire_devis,
          });
        } else {
          this.devis.mainContactDevis = emptyContact;
        }

        this.devis.user_attribution = devisTmp.user_attribution;

        for (let ijk = 0; ijk < devisTmp.listAnnonces.length; ijk++) {
          let annonceTmp = devisTmp.listAnnonces[ijk];
          if (annonceTmp.idfacture) {
            this.isBilled = true;
          }
          this.listeAnnonces.push({
            idannonce: annonceTmp.idannonce,
            idtmp: annonceTmp.idannonce,
            idpublication: annonceTmp.idpublication,
            numero: annonceTmp.numero,
            hors_serie: annonceTmp.numero ? false : true,
            date_previsionnelle: annonceTmp.date_previsionnelle,
            montant: annonceTmp.montant,
            remise: annonceTmp.remise,
            remise_fixe: annonceTmp.remise_fixe,
            type: annonceTmp.type,
            nom: annonceTmp.nom,
            size: annonceTmp.size,
            idpartenaire_facturation: annonceTmp.idpartenaire_facturation,
            idcontacts_partenaire_facturation:
              annonceTmp.idcontacts_partenaire_facturation,
            commentaire: annonceTmp.commentaire,
          });
        }

        this.devisBak = cloneDeep(this.devis);
        this.listAnnoncesBak = cloneDeep(this.listeAnnonces);
      } catch (error) {
        console.log(error);
      }
    },
    async deleteDevis() {
      try {
        let params = { iddevis: this.iddevis };
        await axios.delete("/api/publications/devis", { params: params });
        this.launchEpicmaxToast("Devis supprimé");
        this.closeModal();
        this.$emit("modified", this.iddevis);
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors de la suppression");
      }
    },
    async modifyDevis() {
      if (!this.$store.getters.user.publication_modifications) {
        this.launchEpicmaxToast("Droit insufisants");
        return;
      }
      try {
        if (this.isvalid !== "success") {
          this.launchEpicmaxToast("Devis invalide");
          return;
        }
        let devis = {
          iddevis: this.iddevis,
          idpartenaire: this.devis.partenaire.idpartenaire,
          idcontacts_partenaire_billing:
            this.devis.mainContactBilling.idcontacts_partenaire,
          idcontacts_partenaire_devis:
            this.devis.mainContactDevis.idcontacts_partenaire,
          listAnnonces: this.listeAnnonces,
          attributionChange: this.attribution,
          tva_na: this.devis.tva_na,
          comment_client: this.devis.comment_client,
          annoncesChanged: false,
          devisChanged: false,
          isprospection: this.devis.isprospection,
        };

        if (!isEqual(this.listeAnnonces, this.listAnnoncesBak)) {
          devis.annoncesChanged = true;
        }
        if (!isEqual(this.devis, this.devisBak)) {
          devis.devisChanged = true;
        }

        let params = { devis: devis };

        let idDevis = await axios.put("/api/publications/modify-devis", params);

        this.launchEpicmaxToast("Devis modifié");
        this.closeModal();
        this.$emit("modified", this.iddevis);
      } catch (error) {
        this.launchEpicmaxToast("Erreur lors de la sauvegarde du devis");
      }
    },
    validateAnnonce(annonce) {
      // check that an annonce is valid
      if (annonce.idpublication && annonce.type && annonce.montant > 0) {
        return true;
      } else {
        return false;
      }
    },
    closeModifAnnonce() {
      if (this.specialBilling) {
        this.listeAnnonces[this.idAnnonce].idpartenaire_facturation =
          this.partenaireSpecialBilling.idpartenaire;
        this.listeAnnonces[this.idAnnonce].idcontacts_partenaire_facturation =
          this.contactSpecialBilling.idcontacts_partenaire;
      }
      this.partenaireSpecialBilling = { idpartenaire: null };
      this.contactSpecialBilling = { idcontacts_partenaire: null };
      this.specialBilling = false;
      this.idAnnonce = null;
    },
    deleteAnnonce(index) {
      this.action = true;
      this.idAnnonce = null;
      this.listeAnnonces.splice(index, 1);
    },
    initTemplate() {
      return {};
    },
    editAnnonce(index) {
      this.action = true;
      this.idAnnonce = index;
      if (this.listeAnnonces[this.idAnnonce].idpartenaire_facturation) {
        this.specialBilling = true;
      } else {
        this.specialBilling = false;
      }
      if (
        this.listeAnnonces[this.idAnnonce].montant &&
        this.listeAnnonces[this.idAnnonce].remise
      ) {
        this.remiseChiffre = (
          (this.listeAnnonces[this.idAnnonce].montant *
            this.listeAnnonces[this.idAnnonce].remise) /
          100
        ).toFixed(2);
      } else {
        this.remiseChiffre = null;
      }
      this.showModal = true;
    },
    selectAnnonce(index) {
      if (this.action) {
        this.action = false;
        return;
      }
      this.idAnnonce = index;
    },
    addAnnonce(publication) {
      this.listeAnnonces.push({
        idtmp: this.listeAnnonces.length,
        idpublication: publication.idpublication,
        numero: publication.numero,
        hors_serie: publication.hors_serie,
        date_previsionnelle: publication.date_previsionnelle,
        montant: null,
        remise: null,
        remise_fixe: null,
        type: null,
        nom: null,
        size: null,
        idpartenaire_facturation: null,
        idcontacts_partenaire_facturation: null,
        commentaire: null,
      });
    },
    async loadTemplatesListe() {
      try {
        let resTmp = await axios.get("/api/publications/templateList");
        this.listTemplate = resTmp.data;
      } catch (error) {
        //todo message to user
        console.log(error);
      }
    },
    async loadPublicationListe() {
      try {
        let resTmp = await axios.get("/api/publications/list");
        this.publicationsListe = resTmp.data;
      } catch (error) {
        console.log(error);
      }
    },

    async getContacts(idpartenaire) {
      try {
        let resTmp = await axios.get(
          "/api/publications/liste-contacts-partenaire",
          {
            params: { idpartenaire: idpartenaire },
          }
        );
        return resTmp.data;
      } catch (error) {
        console.log(error);
      }
    },
    async loadPartenairesListe() {
      try {
        let resTmp = await axios.get("/api/publications/liste-partenaires");
        this.partenairesListe = resTmp.data;
      } catch (error) {
        console.log(error);
      }
    },
    resetDevis() {
      this.loadPartenairesListe();
      this.loadPublicationListe();
      this.loadTemplatesListe();
      this.listeAnnonces = [];
      this.idAnnonce = null;
      this.isBilled = false;

      this.devis = {
        idattribution: null,
        tva_na: false,
        partenaire: { idpartenaire: null, nom: null },
        mainContactBilling: { idcontacts_partenaire: null, display: null },
        mainContactDevis: { idcontacts_partenaire: null, display: null },
        user_attribution: null,
        isprospection: false,
      };
      this.mainContactList = [];
    },

    backgroundColor(publication) {
      if (publication.isactif) {
        return "#4ae387";
      } else if (publication.date_cloture) {
        return "#ccc";
      } else {
        return "#4ab2e3";
      }
    },

    closeModal() {
      this.resetDevis();
      this.$emit("close", false);
      this.$emit("input", false);
    },
    updateAnnonce(idannonce, values) {
      this.listeAnnonces[idannonce].nom = values.nom;
      this.listeAnnonces[idannonce].size = values.size;
      this.listeAnnonces[idannonce].montant = values.montant;
      this.listeAnnonces[idannonce].remise = values.remise;
      this.listeAnnonces[idannonce].remise_fixe = values.remise_fixe;

      this.listeAnnonces[idannonce].type = values.type;
      this.listeAnnonces[idannonce].commentaire = values.commentaire;

      this.idAnnonce = null;
      this.templateSelect = { idannonces_modele: null, nom: null };
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
    async changePartenaire(newvalue) {
      if (newvalue.idpartenaire) {
        let listContacts = await this.getContacts(newvalue.idpartenaire);
        this.devis.mainContactBilling = {
          idcontacts_partenaire: null,
          display: "Entreprise - Adresse principale",
        };
        this.devis.mainContactDevis = {
          idcontacts_partenaire: null,
          display: "Entreprise - Adresse principale",
        };
        this.mainContactList = listContacts;
        this.mainContactList.unshift(this.devis.mainContactBilling);
      } else {
      }
    },
  },
  computed: {
    isvalid: function () {
      if (this.devis.partenaire.idpartenaire && this.listeAnnonces.length > 0) {
        for (let ijk = 0; ijk < this.listeAnnonces.length; ijk++) {
          if (!this.validateAnnonce(this.listeAnnonces[ijk])) {
            return "info";
          }
        }
        return "success";
      } else {
        return "info";
      }
    },
    montants: function () {
      let total = 0;
      let remise = 0;

      for (let ijk = 0; ijk < this.listeAnnonces.length; ijk++) {
        total += this.listeAnnonces[ijk].montant
          ? parseFloat(this.listeAnnonces[ijk].montant)
          : 0;
        remise += this.listeAnnonces[ijk].remise
          ? (parseFloat(this.listeAnnonces[ijk].remise) *
              parseFloat(this.listeAnnonces[ijk].montant)) /
            100
          : 0;
        remise += this.listeAnnonces[ijk].remise_fixe
          ? parseFloat(this.listeAnnonces[ijk].remise_fixe)
          : 0;
      }

      return { total: total.toFixed(2), remise: remise.toFixed(2) };
    },
    decomptePages: function () {
      let cptQuart = 0;
      let cptDemi = 0;
      let cptFull = 0;
      let total = 0;

      for (let ijk = 0; ijk < this.listeAnnonces.length; ijk++) {
        if (this.listeAnnonces[ijk].size === "1/4") {
          cptQuart += 1;
          total += 0.25;
        } else if (this.listeAnnonces[ijk].size === "1/2") {
          cptDemi += 1;
          total += 0.5;
        } else if (this.listeAnnonces[ijk].size === "1") {
          cptFull += 1;
          total += 1;
        }
      }

      return {
        text:
          +cptFull +
          " pages / " +
          cptDemi +
          " demis pages / " +
          cptQuart +
          " quarts de pages",
        total: total + " pages",
      };
    },
    decomptesNumeros: function () {
      let listeNumeros = [];
      for (let ijk = 0; ijk < this.listeAnnonces.length; ijk++) {
        listeNumeros.push(this.listeAnnonces[ijk].numero);
      }
      listeNumeros = sortedUniq(sortBy(listeNumeros));
      return listeNumeros.length;
    },
    publicationsListeFiltered: function () {
      return this.publicationsListe.filter((element) => {
        if (element.date_parution) {
          return false;
        }

        return true;
      });
    },
    saveMessage: function () {
      return "Fermer";
    },
  },
  watch: {
    showCommentsClient(newvalue) {
      if (newvalue === true) {
        this.comment_client = this.devis.comment_client;
      } else {
        //forcing change in the devis in order to trigger watcher
        this.devis.tva_na = !this.devis.tva_na;
        this.devis.comment_client = this.comment_client;
        this.devis.tva_na = !this.devis.tva_na;
      }
    },
    devis: {
      deep: true,
      immediate: true,
      handler() {
        if (
          !isEqual(this.devis, this.devisBak) ||
          !isEqual(this.listeAnnonces, this.listAnnoncesBak) ||
          this.attribution
        ) {
          this.isChanged = true;
        } else {
          this.isChanged = false;
        }
      },
    },
    listeAnnonces: {
      deep: true,
      handler() {
        if (
          !isEqual(this.devis, this.devisBak) ||
          !isEqual(this.listeAnnonces, this.listAnnoncesBak) ||
          this.attribution
        ) {
          this.isChanged = true;
        } else {
          this.isChanged = false;
        }
      },
    },
    specialBilling(newvalue) {
      if (newvalue) {
        if (this.listeAnnonces[this.idAnnonce].idpartenaire_facturation) {
          let tmp = {
            idpartenaire:
              this.listeAnnonces[this.idAnnonce].idpartenaire_facturation,
            nom: find(this.partenairesListe, {
              idpartenaire:
                this.listeAnnonces[this.idAnnonce].idpartenaire_facturation,
            }).nom,
          };

          // force watch without deep
          this.partenaireSpecialBilling = tmp;
        } else {
          this.partenaireSpecialBilling = this.devis.partenaire;
          this.partenaireSpecialBilling.nom = find(this.partenairesListe, {
            idpartenaire: this.partenaireSpecialBilling.idpartenaire,
          }).nom;
        }
      } else {
        this.partenaireSpecialBilling = { idpartenaire: null };
        this.contactSpecialBilling = { idcontacts_partenaire: null };
      }
    },
    async partenaireSpecialBilling(newvalue, oldvalue) {
      if (newvalue.idpartenaire) {
        // load contact list
        let listContact = await this.getContacts(newvalue.idpartenaire);

        listContact.unshift({
          idcontacts_partenaire: null,
          display: "Entreprise - Adresse principale",
        });
        if (
          !this.listeAnnonces[this.idAnnonce]
            .idcontacts_partenaire_facturation ||
          newvalue.idpartenaire !==
            this.listeAnnonces[this.idAnnonce].idpartenaire_facturation
        ) {
          this.contactSpecialBilling = {
            idcontacts_partenaire: null,
            display: "Entreprise - Adresse principale",
          };
        } else {
          this.contactSpecialBilling = find(listContact, {
            idcontacts_partenaire:
              this.listeAnnonces[this.idAnnonce]
                .idcontacts_partenaire_facturation,
          });
        }

        this.listContactSpecialBilling = listContact;
      }
    },

    templateSelect(newvalue) {
      if (newvalue.nom !== null) {
        this.updateAnnonce(this.idAnnonce, newvalue);
      }
    },
    value() {
      // Parent property changed; update internal variables
      this.showEdition = this.value;
      this.resetDevis();
      if (this.showEdition) {
        this.loadPartenairesListe();
        this.loadPublicationListe();
        this.loadTemplatesListe();
        this.getDevis();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.popover {
  z-index: 1500;
}
.force-width-comments {
  width: 30vw;
}
.force-width-medium {
  width: 30vw;
  height: 60vh;
  overflow: auto;
}
.forcewidth {
  width: 85vw;
  height: 75vh;
  overflow: auto;
}
.fullwidth {
  width: 90%;
}

.pub {
  float: left;
  text-align: center;
  padding: 0.5em;
  color: white;
  margin: 0.5em;
}

.pub:hover {
  cursor: pointer;
}

.separated {
  border-bottom: solid 1px #ccc;
}

.annonces {
  padding: 10px;
}
.annonces:hover {
  background-color: rgb(223, 223, 223);
}
</style>
